<template>
  <div>
    <!-- Sidebar -->
    <div class="sidebar" id="sidebar">
      <vue-custom-scrollbar class="scroll-area" :settings="settings" @ps-scroll-x="scrollHanle">
        <div class="sidebar-menu">
          <ul>
            <li class="index">
              <router-link to="/index">
                <i class="la la-home"></i>
                <span>Back to Home</span>
              </router-link>
            </li>
            <li class="menu-title">Settings</li>
            <li class="settings" :class="{'active': currentpage === 'settings'}">
              <router-link to="/settings">
                <i class="la la-building"></i>
                <span>Profile</span>
              </router-link>
            </li>
            <li
              class="settings"
              :class="{'active': currentpage === 'settings_billing'}"
              v-if="isJoinAffiliate==true"
            >
              <router-link to="/settings/billing">
                <i class="la la-bank"></i>
                <span>Billing</span>
              </router-link>
            </li>
            <li class="localization" :class="{'active': currentpage === 'localization'}">
              <router-link to="/localization">
                <i class="la la-clock-o"></i>
                <span>Localization</span>
              </router-link>
            </li>
            <li class="changepassword" :class="{'active': currentpage === 'changepassword'}">
              <router-link to="/changepassword">
                <i class="la la-lock"></i>
                <span>Change Password</span>
              </router-link>
            </li>
            <!-- <template v-if="isJoinAffiliate==false">
              <li class="referral" :class="{'active': currentpage === 'referral'}">
                <router-link to="/referral">
                  <i class="la la-sitemap"></i>
                  <span>Affiliate Program</span>
                </router-link>
              </li>
            </template> -->
            <!-- <template v-if="isJoinAffiliate==true">
              <li class="menu-title">Affiliate Program</li>
              <li class="referral" :class="{'active': currentpage === 'referral_link'}">
                <router-link to="/referral/link">
                  <i class="la la-share"></i>
                  <span>Referral Link</span>
                </router-link>
              </li>
              <li class="referral" :class="{'active': currentpage === 'referral_commission'}">
                <router-link to="/referral/commission">
                  <i class="la la-money"></i>
                  <span>Commission</span>
                </router-link>
              </li>
              <li class="referral" :class="{'active': currentpage === 'referral_faq'}">
                <router-link to="/referral/faq">
                  <i class="la la-question"></i>
                  <span>Faq</span>
                </router-link>
              </li>
            </template>-->
          </ul>
        </div>
      </vue-custom-scrollbar>
    </div>
    <!-- Sidebar -->
  </div>
</template>
<script>
import vueCustomScrollbar from "vue-custom-scrollbar";
import "vue-custom-scrollbar/dist/vueScrollbar.css";
export default {
  components: {
    vueCustomScrollbar
  },
  computed: {
    currentpage() {
      return this.$route.name;
    },
    isJoinAffiliate() {
      return this.$store.state.referral.isJoin;
    }
  },
  data() {
    return {
      settings: {
        suppressScrollX: false
      },
      activeClass: "active"
    };
    //  isactive : true
  },
  methods: {
    scrollHanle(evt) {
      console.log(evt);
    }
  }
};
</script>
<style>
.scroll-area {
  position: relative;
  margin: auto;
  height: calc(100vh - 60px);
  background-color: transparent !important;
}
.sidebar {
  height: 100vh;
  overflow: auto;
}

.sidebar::-webkit-scrollbar {
  width: 7px;
}

/* Track */
.sidebar::-webkit-scrollbar-track {
  /* box-shadow: inset 0 0 5px grey;  */
  box-shadow: none;
  border-radius: 10px;
}

/* Handle */
.sidebar::-webkit-scrollbar-thumb {
  /* background: red;  */
  border-radius: 10px;
  /* background: rgb(204, 204, 204); */
  background-color: transparent;
}

/* Handle on hover */
.sidebar::-webkit-scrollbar-thumb:hover {
  /* background: #b30000;  */
  background: rgb(204, 204, 204);
}
.sidebar-menu ul ul a.class-active {
  color: #00c5fb;
  text-decoration: underline;
}
</style> 
  


// WEBPACK FOOTER //
// src/components/layouts/SidebarPromotion.vue